<div class="side-menu" [class.expanded]="isMenuExpanded">
  <ul>
    <li [title]="'Dashboard'">
      <a routerLink="/backoffice/dashboard">
        <i class="material-icons">dashboard</i>
        <span *ngIf="isMenuExpanded">Dashboard</span>
      </a>
    </li>

    <li [title]="'Transacciones'" [class.open]="isTransaccionesOpen">
      <div class="menu-item" (click)="toggleTransacciones()">
        <i class="material-icons">swap_horiz</i>
        <span *ngIf="isMenuExpanded">Transacciones</span>
        <i class="material-icons" *ngIf="isMenuExpanded">
          {{ isTransaccionesOpen ? 'expand_less' : 'expand_more' }}
        </i>
      </div>
      <ul class="submenu" *ngIf="isMenuExpanded && isTransaccionesOpen">
        <li>
          <a routerLink="/backoffice/transactions">Transacción List</a>
        </li>
        <li>
          <a routerLink="/backoffice/txusuarios">Tx Usuarios</a>
        </li>
      </ul>
    </li>

    <li [title]="'Reportes'">
      <a routerLink="/backoffice/reports">
        <i class="material-icons">bar_chart</i>
        <span *ngIf="isMenuExpanded">Reportes</span>
      </a>
    </li>
    <li [title]="'Usuarios'">
      <a routerLink="/backoffice/users">
        <i class="material-icons">group</i>
        <span *ngIf="isMenuExpanded">Usuarios</span>
      </a>
    </li>
    <li [title]="'Partners BTB'">
      <a routerLink="/backoffice/partners">
        <i class="material-icons">business</i>
        <span *ngIf="isMenuExpanded">Partners BTB</span>
      </a>
    </li>

    <li [title]="'Herramientas'">
      <a routerLink="/backoffice/herramientas">
        <i class="material-icons">build</i>
        <span *ngIf="isMenuExpanded">Herramientas</span>
      </a>
    </li>

    <li [title]="'Configuraciones'" [class.open]="isconfigsopen">
      <div class="menu-item" (click)="toggleconfig()">
        <i class="material-icons">settings</i>
        <span *ngIf="isMenuExpanded">Configuraciones</span>
        <i class="material-icons" *ngIf="isMenuExpanded">
          {{ isconfigsopen ? 'expand_less' : 'expand_more' }}
        </i>
      </div>
      <ul class="submenu" *ngIf="isMenuExpanded && isconfigsopen">
        <li>
          <a routerLink="/backoffice/configs">Globales</a>
        </li>
        <li>
          <a routerLink="/backoffice/conditions/promo">Promos</a>
        </li>
         <!-- <li>
          <a routerLink="/backoffice/conditions/send_money">send money</a>
        </li> -->
         <li>
          <a routerLink="/backoffice/conditions/partner">Partner</a>
        </li>
      </ul>
    </li>


    <!-- <li [title]="'Configuraciones'">
      <a routerLink="/backoffice/configs">
        <i class="material-icons">settings</i>
        <span *ngIf="isMenuExpanded">Configuraciones</span>
      </a>
    </li> -->
  </ul>

  <button (click)="toggleMenu()" class="toggle-btn">
    <i class="material-icons">{{ isMenuExpanded ? 'chevron_left' : 'menu' }}</i>
  </button>
</div>

<div class="main-content" [class.menu-expanded]="isMenuExpanded">
  <ng-content></ng-content>
</div>
